import { queryClient } from '@/queryClient';
import { API_TABELA_PRECO_CONSULTAR_KEY } from '../api/apiTabelaPrecoConsultar';
import { API_TABELA_PRECO_PRODUTO_KEY } from '../api/apiTabelaPrecoProduto';

export function invalidateTabelaPrecoQueries(): void {
    void queryClient.invalidateQueries({
        queryKey: [API_TABELA_PRECO_CONSULTAR_KEY],
    });

    void queryClient.invalidateQueries({
        queryKey: [API_TABELA_PRECO_PRODUTO_KEY],
    });
}
